module.exports = "/packs/multicreator_banner-854c739b02eaa9f2d5acfbc870ac8895.png";